<template>
  <div class="tile is-ancestor" :class="{ wrap: wrap }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Tiles',
  props: {
    link: {
      default: null,
    },
    icon: {
      type: String,
    },
    wrap: {
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/colors.scss';

.wrap {
  flex-wrap: wrap;
}
</style>
